export default __webpack_public_path__ + "static/media/detox1.87dfdc10.jpg";